import { translationsEnUS } from "../translations/en-US";

export type LanguageTranslationsKeys = typeof translationsEnUS;

export enum LocalesDict {
  FRENCH = "fr-FR",
  ENGLISH_US = "en-US",
}

export type AvailableLanguageOnApp = `${LocalesDict}`;

export type LangObject = {
  translatedText: LanguageTranslationsKeys;
  pictureName: AvailableLanguageOnApp;
  langID: number;
  locale: AvailableLanguageOnApp;
  isDefault?: boolean;
};

export type LangCompleteData = Record<AvailableLanguageOnApp, LangObject>;
